import React from 'react';
import SuccessScreen from '../../Common/SuccessScreen';

const PaymentFailed = () => (
  <SuccessScreen
    icon='https://d2djimvzddgguw.cloudfront.net/humbee-payments/disclaimer-icon.svg'
    title="Payment failed!"
    subtitle="Please try again or use another payment method."
  />
);

export default PaymentFailed;
